<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="spinner-wrapper">
    <span class="spinner"></span>
  </div>
</template>

<style lang="scss" scoped>
.spinner-wrapper {
  --spinner-bg: #{rgba($c-white, 0.6)};
  --spinner-color-primary: #{$c-white};
  --spinner-color-secondary: #{$c-green-abr};
  --spinner-width: 6rem;
  --spinner-thickness: 1rem;

  @include get-all-space;

  z-index: 2;
  display: flex;
  background: var(--spinner-bg);
}

.spinner {
  display: inline-block;
  box-sizing: border-box;
  width: var(--spinner-width);
  height: var(--spinner-width);
  margin: $spacing * 4 auto 0;
  background: transparent;
  border: var(--spinner-thickness) solid var(--spinner-color-primary);
  border-bottom-color: var(--spinner-color-secondary);
  border-radius: 50%;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
